document.addEventListener('DOMContentLoaded', function() {
  console.log('=== FIXING 422 CART ADD ERROR ===');
  
  // Set up product data immediately
  function initializeProductData() {
    if (typeof window.productData === 'undefined') {
      // Try to find product data from the JSON script tag
      const productScript = document.querySelector('script[type="application/json"]');
      if (productScript) {
        try {
          const productJson = JSON.parse(productScript.textContent);
          if (productJson.product && productJson.product.variants) {
            window.productData = {
              variants: productJson.product.variants.map(variant => ({
                id: variant.id,
                available: variant.available,
                option1: variant.option1,
                option2: variant.option2,
                option3: variant.option3,
                title: variant.title
              }))
            };
            console.log('Product data initialized:', window.productData);
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
      
      // Fallback: create empty structure
      if (typeof window.productData === 'undefined') {
        window.productData = { variants: [] };
      }
    }
  }

  // Function to find the correct variant ID based on current selections
  function findCorrectVariantId() {
    const productData = window.productData || {};
    const variants = productData.variants || [];
    
    if (variants.length === 0) {
      console.log('No variants available');
      return null;
    }

    // Get current selections
    const selectedOptions = {};
    
    // Get size from URL parameter first (highest priority)
    const urlParams = new URLSearchParams(window.location.search);
    const urlSize = urlParams.get('size');
    if (urlSize) {
      selectedOptions['Size'] = urlSize;
      console.log('Size from URL:', urlSize);
    }
    
    // Get size from radio inputs
    const sizeInputs = document.querySelectorAll('input[type="radio"]:checked[name*="size"], input[type="radio"]:checked[name*="Size"], input[type="radio"]:checked[name^="option-"]');
    sizeInputs.forEach(input => {
      if (!input.classList.contains('color-option-input')) {
        selectedOptions['Size'] = input.value;
        console.log('Size from radio input:', input.value);
      }
    });
    
    // Get color from current product (if we're on a specific color variant)
    const currentVariantInput = document.querySelector('input[name="id"]');
    if (currentVariantInput && currentVariantInput.value) {
      const currentVariant = variants.find(v => v.id == currentVariantInput.value);
      if (currentVariant && currentVariant.option1) {
        selectedOptions['Color'] = currentVariant.option1;
        console.log('Color from current variant:', currentVariant.option1);
      }
    }
    
    console.log('Current selections:', selectedOptions);
    
    // Find matching variant
    let matchingVariant = null;
    
    // Try to match with both color and size
    if (selectedOptions['Color'] && selectedOptions['Size']) {
      matchingVariant = variants.find(variant => 
        variant.option1 === selectedOptions['Color'] && 
        variant.option2 === selectedOptions['Size']
      );
    }
    
    // If no match with both, try just size
    if (!matchingVariant && selectedOptions['Size']) {
      matchingVariant = variants.find(variant => 
        variant.option2 === selectedOptions['Size']
      );
    }
    
    // If still no match, try just color
    if (!matchingVariant && selectedOptions['Color']) {
      matchingVariant = variants.find(variant => 
        variant.option1 === selectedOptions['Color']
      );
    }
    
    // Fallback to first available variant
    if (!matchingVariant) {
      matchingVariant = variants.find(variant => variant.available);
    }
    
    // Last resort: first variant
    if (!matchingVariant) {
      matchingVariant = variants[0];
    }
    
    console.log('Found matching variant:', matchingVariant);
    return matchingVariant;
  }

  // Function to update variant ID input
  function updateVariantIdInput() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) {
      console.error('No variant ID input found!');
      return false;
    }

    const correctVariant = findCorrectVariantId();
    if (!correctVariant) {
      console.error('No correct variant found!');
      return false;
    }

    const oldValue = variantInput.value;
    variantInput.value = correctVariant.id;
    
    console.log('Updated variant ID from', oldValue, 'to', correctVariant.id);
    
    // Trigger change event
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    
    return true;
  }

  // Function to validate form before submission
  function validateFormData() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      console.error('No variant ID selected!');
      return false;
    }

    const variantId = variantInput.value;
    console.log('Validating variant ID:', variantId);
    
    // Check if variant exists in product data
    const productData = window.productData || {};
    const variants = productData.variants || [];
    const selectedVariant = variants.find(v => v.id == variantId);
    
    if (!selectedVariant) {
      console.error('Selected variant not found in product data:', variantId);
      return false;
    }
    
    if (!selectedVariant.available) {
      console.warn('Selected variant is not available:', selectedVariant);
      // Don't return false here - let Shopify handle the unavailable case
    }
    
    console.log('Form validation passed for variant:', selectedVariant);
    return true;
  }

  // Intercept form submissions to ensure correct variant ID
  function interceptFormSubmissions() {
    // Find the product form
    const productForms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart"], .product-form form');
    
    productForms.forEach(form => {
      console.log('Adding validation to form:', form);
      
      form.addEventListener('submit', function(e) {
        console.log('=== FORM SUBMISSION INTERCEPTED ===');
        
        // Update variant ID before submission
        const updated = updateVariantIdInput();
        if (!updated) {
          console.error('Could not update variant ID - preventing submission');
          e.preventDefault();
          return false;
        }
        
        // Validate form data
        const isValid = validateFormData();
        if (!isValid) {
          console.error('Form validation failed - preventing submission');
          e.preventDefault();
          return false;
        }
        
        console.log('Form submission validation passed');
      });
    });
    
    // Also intercept any add-to-cart button clicks
    const addToCartButtons = document.querySelectorAll('#AddToCart, [data-add-to-cart], .btn-add-to-cart, button[type="submit"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        console.log('=== ADD TO CART BUTTON CLICKED ===');
        
        // Small delay to allow any other scripts to run first
        setTimeout(() => {
          updateVariantIdInput();
        }, 10);
      });
    });
  }

  // Handle size changes
  function setupSizeChangeHandlers() {
    document.addEventListener('change', function(e) {
      // Check if this is a size option change
      if (e.target.matches('input[type="radio"]') && 
          (e.target.name.includes('size') || 
           e.target.name.includes('Size') || 
           e.target.name.startsWith('option-')) &&
          !e.target.classList.contains('color-option-input')) {
        
        console.log('Size option changed to:', e.target.value);
        
        // Update variant ID after a short delay
        setTimeout(() => {
          updateVariantIdInput();
        }, 50);
      }
    });
  }

  // Set up size from URL parameter
  function setupSizeFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSize = urlParams.get('size');
    
    if (urlSize) {
      console.log('Setting up size from URL:', urlSize);
      
      // Find and check the appropriate size radio button
      const sizeSelectors = [
        `input[type="radio"][value="${urlSize}"]`,
        `input[name*="size"][value="${urlSize}"]`,
        `input[name*="Size"][value="${urlSize}"]`
      ];
      
      for (const selector of sizeSelectors) {
        const sizeInput = document.querySelector(selector);
        if (sizeInput && !sizeInput.classList.contains('color-option-input')) {
          sizeInput.checked = true;
          console.log('Checked size input for:', urlSize);
          break;
        }
      }
    }
  }

  // Initialize everything
  console.log('Initializing 422 error fix...');
  
  initializeProductData();
  setupSizeFromUrl();
  
  // Update variant ID initially
  setTimeout(() => {
    updateVariantIdInput();
  }, 100);
  
  setupSizeChangeHandlers();
  interceptFormSubmissions();
  
  console.log('=== 422 ERROR FIX INITIALIZED ===');
});